import { Injectable } from '@angular/core';
import { Router,CanActivate, CanActivateChild, CanDeactivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthenticationService}from './../service/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {

  constructor(
    private router: Router,
    private service: AuthenticationService
) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const currentUser = this.service.currentUserValue;
      if (currentUser) {
        if(next.data.permission){
         
           let module=next.data.permission;
           this.service.permissionCheck(module).subscribe((res:any)=>{
             if(res.status == true){
              return true;
             }else {
             
              this.router.navigate(['/']);
              return false;
             }
            
 
 
           });
           return true;
          } else{
           return true;
          }
      } 

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/wgiacm'], { queryParams: { returnUrl: state.url } });
    return false;
 
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const currentUser = this.service.currentUserValue;
      if (currentUser) {
        if(next.data.permission){
         
           let module=next.data.permission;
           this.service.permissionCheck(module).subscribe((res:any)=>{
             if(res.status == true){
              return true;
             }else {
             
              this.router.navigate(['/']);
              return false;
             }
            
 
 
           });
           return true;
          } else{
           return true;
          }
      } 

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/parking/wgiacm'], { queryParams: { returnUrl: state.url } });
    return false;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
